import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";

export const resolveAuthRedirectPath = (redirectPath: string | null, site: SiteSlug): string => {
    const normalizedRedirectPath = normalizeRedirectPath(redirectPath);

    if (normalizedRedirectPath) {
        return normalizedRedirectPath;
    }

    return kmAppLink.site.dashboard({site});
};

const normalizeRedirectPath = (redirectPath: string | null): string | null => {
    if (!redirectPath) {
        return null;
    }

    const trimmedRedirectPath = redirectPath.trim();
    if (!trimmedRedirectPath.startsWith("/") || trimmedRedirectPath.startsWith("//")) {
        return null;
    }

    return trimmedRedirectPath.replace(/\/%3F/i, "/?");
};
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";

export const resolveAuthRedirectPath = (redirectPath: string | null, site: SiteSlug): string => {
    const normalizedRedirectPath = normalizeRedirectPath(redirectPath);

    if (normalizedRedirectPath) {
        return normalizedRedirectPath;
    }

    return kmAppLink.site.dashboard({site});
};

const normalizeRedirectPath = (redirectPath: string | null): string | null => {
    if (!redirectPath) {
        return null;
    }

    const trimmedRedirectPath = redirectPath.trim();
    if (!trimmedRedirectPath.startsWith("/") || trimmedRedirectPath.startsWith("//")) {
        return null;
    }

    return trimmedRedirectPath.replace(/\/%3F/i, "/?");
};
